import { cn } from '@/lib/utils'
import { Slot } from '@radix-ui/react-slot'
import { type VariantProps, cva } from 'class-variance-authority'
import * as React from 'react'

const textVariants = cva('', {
	defaultVariants: {
		size: 'default',
		text: 'default',
	},
	variants: {
		size: {
			default: 'text-base text-lg text-gray-500',
		},
		text: {
			default: 'font-dm',
		},
	},
})

interface TextProps extends React.HtmlHTMLAttributes<HTMLHeadingElement>, VariantProps<typeof textVariants> {
	asChild?: boolean
}

const Text = React.forwardRef<HTMLHeadingElement, TextProps>(({ asChild = false, className, size, ...props }, ref) => {
	const Comp = asChild ? Slot : 'h1'
	return <Comp className={cn(textVariants({ className, size }))} ref={ref} {...props} />
})
Text.displayName = 'Text'

export { Text, type TextProps, type textVariants }
